import PropTypes from "prop-types";

export const message = {
  role: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  complete: PropTypes.bool.isRequired,
};

export const toolCallMessage = PropTypes.shape({
  ...message,
  count: PropTypes.number.isRequired,
});
